import React, { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { Input } from "components/bootstrap";
import FormDataContext from "integrations/contexts/FormDataContext";
import { AWS_AUTH_TYPES } from "integrations/aws/common/constants";
import AppConfig from "util/AppConfig";
import KeySecret from "./KeySecret";
import Automatic from "./Automatic";
import ARN from "./ARN";
const AuthWrapper = styled.div(
  ({ theme }) => css`
    margin: 0 0 21px 9px;
    padding: 3px 0 3px 21px;
    border-left: 3px solid ${theme.colors.gray[80]};
  `
);
const AWSAuthenticationTypes = ({ onChange, requireCredentials = true }) => {
  const { clearField, formData } = useContext(FormDataContext);
  const { awsAuthenticationType, awsAccessKey, awsSecretKey, awsAssumeRoleARN, awsExternalId } = formData;
  let defaultAuthTypeValue;
  if (AppConfig.isCloud()) {
    defaultAuthTypeValue = AWS_AUTH_TYPES.keysecret;
  } else {
    defaultAuthTypeValue = awsAuthenticationType ? awsAuthenticationType.value : AWS_AUTH_TYPES.automatic;
  }
  const [currentType, setCurrenType] = useState(defaultAuthTypeValue);
  useEffect(() => {
    onChange({ target: { name: "awsAuthenticationType", value: defaultAuthTypeValue } });
  }, []);
  const isType = (type) => currentType === type;
  const handleTypeChange = (e) => {
    setCurrenType(e.target.value);
    onChange({ target: { name: "awsAuthenticationType", value: e.target.value } });
    if (e.target.value === AWS_AUTH_TYPES.automatic) {
      clearField("awsAccessKey");
      clearField("awsSecretKey");
    }
  };
  const isCloud = AppConfig.isCloud();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isCloud ? /* @__PURE__ */ React.createElement(KeySecret, { awsKey: awsAccessKey, awsSecret: awsSecretKey, onChange, required: requireCredentials }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "select",
      name: "awsAuthType",
      id: "awsAuthType",
      onChange: handleTypeChange,
      label: "AWS Authentication Type",
      defaultValue: currentType
    },
    Object.keys(AWS_AUTH_TYPES).map((type) => /* @__PURE__ */ React.createElement("option", { value: AWS_AUTH_TYPES[type], key: `option-${type}` }, AWS_AUTH_TYPES[type]))
  ), /* @__PURE__ */ React.createElement(AuthWrapper, null, isType(AWS_AUTH_TYPES.automatic) && /* @__PURE__ */ React.createElement(Automatic, null), isType(AWS_AUTH_TYPES.keysecret) && /* @__PURE__ */ React.createElement(
    KeySecret,
    {
      awsKey: awsAccessKey,
      awsSecret: awsSecretKey,
      onChange,
      required: requireCredentials
    }
  ))), /* @__PURE__ */ React.createElement(ARN, { awsARN: awsAssumeRoleARN, awsExternalId, onChange }));
};
export default AWSAuthenticationTypes;
